// extracted by mini-css-extract-plugin
export default {"submit":"SubmitContactForm_submit__+RpeF","checkbox":"SubmitContactForm_checkbox__apdxx"};